import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ChevronUpIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M7.69455 5.53876C7.88788 5.41159 8.15081 5.43318 8.32101 5.60272L12.3054 9.57171C12.5 9.76546 12.5 10.0795 12.3054 10.2733C12.1109 10.467 11.7957 10.467 11.6012 10.2733L7.96887 6.65504L4.33658 10.2733C4.14207 10.467 3.8268 10.467 3.6323 10.2733C3.43779 10.0795 3.43779 9.76546 3.6323 9.57171L7.61673 5.60272L7.69455 5.53876Z"
      fill="currentColor"
    />
  </svg>
);
